module.exports = __webpack_public_path__ + "img/1521323797.b85cf477.jpg";